import React from "react";
import { Typography } from "@progress/kendo-react-common";

/**
 * A styled paragraph component using Kendo Typography.
 * for more details on (additional) available props. see kendo react api docs.
 *
 * @param {object} props
 * @param {"bold"|"normal"|"light"} props.fontWeight - Font weight option.
 * @param {"center"|"left"|"right"|"justify"} props.textAlign - Text alignment.
 * @param {React.ReactNode} [props.children] - Content inside the paragraph.
 * @returns {JSX.Element}
 *
 * @example
 * <Paragraph fontWeight="normal" textAlign="left">
 *   This is a simple paragraph.
 * </Paragraph>
 */
export const Paragraph = (props) => {

    return (
        <Typography.p {...props}>
            {props.children}
        </Typography.p>
    );
};
